import React, { Component } from "react";
import { connect } from "react-redux";
import { actions as userActions } from "../../redux/modules/user";
import { Link } from "react-router-dom";
import "./style.css";
import "../../index.css";
import "../../index";
import { post } from "../../utils/request";
let params = { phone: "", password: "" };
class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      error_visible: false,
      shake_visible: false,
      error_info: "",
      shown: false,
    };
  }
  render() {
    const { visible } = this.props;
    return (
      <div
        style={visible === true ? { display: "block" } : { display: "none" }}
        className="login_box"
      >
        <div className="login_inline_box">
          <div onClick={() => this.handleClose()} className="login_close">
            <img alt="" src={require("../../images/user/close.png")}></img>
          </div>
          <img
            className="login_img"
            alt=""
            src={require("../../images/user/login.png")}
          ></img>
          <div
            style={
              this.state.error_visible === true
                ? { display: "block" }
                : { display: "none" }
            }
            className={
              this.state.shake_visible === true
                ? "login_error shake"
                : "login_error"
            }
          >
            <span>{this.state.error_info}</span>
            {this.state.error_info === "* 密码有误" ? (
              <Link
                onClick={() => {
                  this.handleClose();
                }}
                to="/user/reset"
              >
                （ 忘记密码？）
              </Link>
            ) : (
              ""
            )}
          </div>
          <div className="login_phone">
            <input
              onChange={this.handlePhoneChang}
              placeholder="请输入手机号"
              className="fl"
            ></input>
            <img
              className="fr"
              alt=""
              src={require("../../images/user/pulldown.png")}
            ></img>
          </div>
          <div className="login_password">
            <input
              onChange={this.handlePasswordChang}
              type={this.state.shown ? "text" : "password"}
              placeholder="请输入密码"
              className="fl"
            ></input>
            <img
              onClick={() => {
                this.setState({
                  shown: !this.state.shown,
                });
              }}
              className="fr"
              alt=""
              src={
                this.state.shown
                  ? require("../../images/user/visible.png")
                  : require("../../images/user/invisible.png")
              }
            ></img>
          </div>
          <div className="login_skip">
            <Link
              onClick={() => {
                this.handleClose();
              }}
              className="fl"
              to="/user/register"
            >
              注册帐号
            </Link>
            <Link
              onClick={() => {
                this.handleClose();
              }}
              className="fr"
              to="/user/reset"
            >
              忘记密码？
            </Link>
            <div className="clear"></div>
          </div>
          <div onClick={() => this.requestLogin()} className="login_btn">
            登 录
          </div>
        </div>
      </div>
    );
  }
  /**
   * 关闭登陆框
   */
  handleClose = () => {
    this.setState({
      error_info: "",
      error_visible: false,
    });
    const { dispatch } = this.props;
    dispatch(userActions.setShowLogin(false));
  };
  /**
   * 手机号码输入记录
   */
  handlePhoneChang = (e) => {
    params.phone = e.target.value;
  };
  /**
   * 密码输入记录
   */
  handlePasswordChang = (e) => {
    params.password = e.target.value;
  };

  /**
   * 移除提示语抖动效果
   */
  handleRemoveShake = () => {
    setTimeout(() => {
      this.setState({
        shake_visible: false,
      });
    }, 800);
  };
  /**
   * 手机号登陆
   */
  requestLogin = () => {
    if (params.phone === "") {
      this.setState({
        error_visible: true,
        error_info: "* 手机号不能为空",
        phone: "",
        shake_visible: true,
      });
      this.handleRemoveShake();
      return;
    }
    if (!(params.phone.length === 11 && params.phone[0] === "1")) {
      this.setState({
        error_visible: true,
        error_info: "* 手机号有误",
        phone: "",
        shake_visible: true,
      });
      this.handleRemoveShake();
      return;
    }
    post("/public/v1/user/login", params).then((res) => {
      const { dispatch } = this.props;
      if (res.status === "success") {
        let userInfo = {
          phone: res.data.phone,
          year: res.data.year,
          isActive: res.data.isActive,
          isLogin: true,
          isBuy: res.data.isBuy,
          discounts: res.data.discounts,
          isWhiteUser: res.data.isWhiteUser,
        };
        dispatch(userActions.setUserInfo(userInfo));
        dispatch(userActions.setUserState("我的"));
        dispatch(userActions.setUserLink("/my"));
        if (res.data.isBuy) {
          dispatch(userActions.setUserDayUpLink("/dayup"));
        }
        this.handleClose();
        return;
      }
      //手机号没有注册
      if (res.status === "fail" && res.data.err_code === 20004) {
        this.handleClose();
        window.location.href =
          window.location.protocol +
          "//" +
          window.location.host +
          "/user/register?phone=" +
          params.phone +
          "&prevPath=" +
          window.location.pathname +
          "";
      } else {
        this.setState({
          error_visible: true,
          error_info: res.data.err_msg,
          shake_visible: true,
        });
        this.handleRemoveShake();
      }
    });
  };
}
const mapStateToProps = (state) => {
  return {
    userUi: state.user.uiStateData,
  };
};
export default connect(mapStateToProps)(Login);



// WEBPACK FOOTER //
// ./src/components/Login/index.js